import * as React from "react"
const SvgAlarmOff = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.15 19.714H5a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h1v-7q0-.825.212-1.625a6 6 0 0 1 .638-1.525l1.5 1.5a4 4 0 0 0-.35 1.65v7h6.2L2.1 5.614a.95.95 0 0 1-.275-.7q0-.424.275-.7a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275l17 17a.98.98 0 0 1 .288.688.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275zm-2.65-14.8q2 .5 3.25 2.113T18 10.714v2.75q0 .501-.313.75a1.045 1.045 0 0 1-1.375-.012Q16 13.939 16 13.439v-2.725q0-1.65-1.175-2.825T12 6.714q-.4 0-.85.1t-.8.25a1.33 1.33 0 0 1-.838.075 1 1 0 0 1-.637-.475.96.96 0 0 1-.138-.687.72.72 0 0 1 .388-.538q.326-.174.675-.3.35-.125.7-.225v-.7q0-.624.438-1.062A1.45 1.45 0 0 1 12 2.714q.624 0 1.063.438.437.437.437 1.062zm-1.5 17.8q-.75 0-1.338-.412-.587-.413-.587-1.113 0-.2.163-.337a.55.55 0 0 1 .362-.138h2.8q.2 0 .362.138a.43.43 0 0 1 .163.337q0 .7-.588 1.113a2.27 2.27 0 0 1-1.337.412" />
  </svg>
)
export default SvgAlarmOff
